/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioOperatoreAssegnazioneItem } from './servizio-operatore-assegnazione-item';


export interface ServizioOperatoriBulkReplaceForm { 
    version: number;
    assegnazioni: Array<ServizioOperatoreAssegnazioneItem>;
}

